import { render, staticRenderFns } from "./Act_details.vue?vue&type=template&id=38e58212&scoped=true"
import script from "./Act_details.vue?vue&type=script&lang=js"
export * from "./Act_details.vue?vue&type=script&lang=js"
import style0 from "./Act_details.vue?vue&type=style&index=0&id=38e58212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e58212",
  null
  
)

export default component.exports